import React from "react";
import RIY from "../../../assets/images/rockinyangon/tickets.jpg";

const WhatWeDo = () => {
  return (
    <div className=" pb-20  md:py-20  grid md:grid-cols-2 gap-10 bg-[#1D1D1D] md:px-8 lg:px-20 ">
      <div className="grid-cols-1 order-2 md:order-1 flex flex-col justify-center gap-4 px-5">
        <div className="w-32 h-[2px] bg-[#E83B37]" />
        <h1 className="capitalize text-[#E83B37] text-3xl lg:text-4xl  titlefont ">
          GET YOUR TICKET NOW
        </h1>
        <p className="text-white lg:text-[20px]  text-base leading-9 tracking-wider">
          ရန်ကုန်မြို့ရဲ့ အကောင်းဆုံး
          <span className="px-1 titlefont text-[#e83b37] font-semibold text-xl">
            Rock
          </span>
          ဂီတပွဲကြီးမှာ အတူလာရောက်ဆင်နွှဲလိုက်ပါ
        </p>
        <p className="text-white/70 tracking-wider leading-9 ">
          တစ်စုံတစ်ခုမေးမြန်းစုံစမ်းလိုပါက
          <a href="" className="text-red-600 lg:text-lg  titlefont underline  ">
            Rock In Yangon Facebook Page Messenger
          </a>
          မှတစ်ဆင့် (သို့မဟုတ်) HOT LINE -
          <span className="text-white text-lg textfont">09258835886 </span>
          မှ ဆက်သွယ်မေးမြန်းနိုင်ပါတယ်
        </p>
        {/* <h1 className="text-2xl font-bold text-white">အောက်တိုဘာ ၂၁ ရက်</h1>
        <h2 className="text-xl textfont font-semibold text-white/70">
          Yangon Hexagon Complex
        </h2>
        <button className="w-[200px] py-2 hover:bg-transparent border border-[#ed3E3D] hover:rounded-lg rounded-md transition-all text-white bg-[#ED3E3D]">
          Ticket ၀ယ်ယူရန်
        </button> */}
      </div>
      <div className="grid-cols-1 order-1 md:order-2 flex items-center justify-end px-5">
        <div className="md:w-[400px] md:pl-10">
          <img src={RIY} className=" w-full" alt="" />
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
